/* eslint-disable @typescript-eslint/no-explicit-any */
import { useContext, useMemo } from 'react';
import { ThemeContext } from 'styled-components';

/**
 * Hook to access theme colors for JavaScript usage.
 * Useful for components that need color values in props (SVG fillColor, canvas operations, etc.)
 *
 * During the CSS variables migration, this provides a stable API for accessing colors
 * while we transition from styled-components theme to CSS custom properties.
 *
 * @returns {Object} Color values as hex strings
 *
 * @example
 * const colors = useCSSColors();
 * <ColoredIcon fillColor={colors.primary} />
 */
export function useCSSColors() {
  const theme = useContext(ThemeContext);

  return useMemo(() => {
    // Passthrough to theme.colors
    // Maintains backwards compatibility during migration
    return (theme as any)?.colors || {};
  }, [theme]);
}
